import {formatDateTime} from 'i18n/localeDateFormat';
import React from 'react';
import {Maybe, PhaseDate} from 'types';
import {v4 as uuidv4} from 'uuid';

export const useMatkonFormUtils = ({classNames, i18n}: any) => {
	const mapToArray = (objArr: {name: string}[]) => {
		return (
			<>
				{objArr.map(k => (
					<div key={uuidv4()} className={classNames.arrayItem}>
						{k.name}
					</div>
				))}
			</>
		);
	};

	const mapToRow = (
		id: string,
		keyPostfix: string,
		objArr: {name: string}[],
	) => {
		return (
			<div key={`${id}-${keyPostfix}`} className={classNames.arrayWrapper}>
				{mapToArray(objArr)}
			</div>
		);
	};

	const mapToPhaseDateRow = (
		key: string,
		dates: Maybe<PhaseDate[]> | undefined,
	) => {
		return (
			<div key={key} className={classNames.arrayWrapper}>
				{dates?.map(phaseDate => (
					<div key={phaseDate.status} className={classNames.arrayItem}>
						{formatDateTime(new Date(phaseDate.date), i18n)} ({phaseDate.status}
						)
					</div>
				))}
			</div>
		);
	};

	const mapToDateRow = (key: string, dateString: string) => {
		return dateString ? (
			<div key={key} className={classNames.arrayWrapper}>
				<div className={classNames.arrayItem}>
					{formatDateTime(new Date(dateString), i18n)}
				</div>
			</div>
		) : (
			<></>
		);
	};
	return {mapToArray, mapToRow, mapToPhaseDateRow, mapToDateRow};
};
